/**
 * Created by Junhua on 2017/5/3.
 * 所有的过滤器写在这里
 */
export default {
    formatDate(date,fmt) {//日期格式化
        // var fmt = 'yyyy-MM-dd hh:mm:ss'
        if(!date) return '';
        var date = new Date(date);
        var o = {
            "M+": date.getMonth() + 1, //月份
            "d+": date.getDate(), //日
            "h+": date.getHours(), //小时
            "m+": date.getMinutes(), //分
            "s+": date.getSeconds(), //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    },
    getRole(value) {
        if(value == 0){
            return "管理员";
        }else if(value == 1){
            return "普通用户";
        }else return '未知'
    },
    getFirmType(value) {
        if(value == 0){
            return "供应商";
        }else if(value == 1){
            return "客户";
        }else return '未知'
    },
    getDocketType(value) {
        if(value == 0){
            return "进货单";
        }else if(value == 1){
            return "出货单";
        }else if(value == 2){
            return "其他单";
        }else return '未知'
    },
    getDocketState(value) {
        if(value == 0){
            return "待处理";
        }else if(value == 1){
            return "已完成";
        }else if(value == 2){
            return "已退货";
        }else return '未知'
    },
    money(value) {
        if(!value){
            return '0.00';
        }else return Number(value).toFixed(2);
    },
}
